import { useCallback } from "react";

import { FieldOption } from "components/FieldSelect/FieldSelect";
import { withSelectedOption } from "services/withSelectedOption";

export function useWithSelectedOption(
	handler: (value: FieldOption["value"]) => void
) {
	return useCallback(
		(newOptions: FieldOption[]) => withSelectedOption(newOptions, handler),
		[handler]
	);
}
